import { createContext, useContext } from 'react';
import type { AuthSessionLike, SessionOutcome } from '@bettercomp/ams-spa-auth';

export type { AuthSessionLike };

export interface AuthContextValue {
  outcome: SessionOutcome | undefined;
  configError: boolean;
  devBypass: boolean;
  session: AuthSessionLike | undefined;
  /** Relays UseAmsAuthSessionResult.reportOutcome; see it for the host-outcome contract. */
  reportOutcome: (outcome: SessionOutcome) => void;
  retry: () => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuthContext(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}
